__turbopack_context__.v({
  "root": "ve_D9W_root",
  "tos": "ve_D9W_tos",
});
